import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import BlueBookTooltip from 'chameleon/packages/blue-book-player/library/tooltip/BlueBookTooltip';
import ButtonWithIcon from 'chameleon/packages/blue-book-player/library/button-with-icon';
import { BluebookContext } from 'chameleon/packages/blue-book-player/state/BluebookContext';
import { isCalculatorAllowed } from 'chameleon/packages/blue-book-player/utils';
import CalculatorTooltipContent from 'chameleon/packages/blue-book-player/library/QuestionCalculator/components/CalculatorTooltipContent';

const QuestionCalculator = ({ learnosityItemReference }) => {
  const { state } = useContext(BluebookContext);

  const allowCalculatorForItems = state?.allowCalculatorForItems ?? {};

  if (!isCalculatorAllowed(allowCalculatorForItems, learnosityItemReference)) {
    return null;
  }

  return (
    <div className="flex">
      <BlueBookTooltip
        tooltipProps={{
          id: 'question-calculator-button',
        }}
        aria-label="Calculator Allowed"
        description={<CalculatorTooltipContent />}
        onButtonPress
        onKeyboardFocus
      >
        <ButtonWithIcon
          icon="question_calculator"
          iconOrientation="left"
          data-cy="question-calculator-button"
        />
      </BlueBookTooltip>
    </div>
  );
};

QuestionCalculator.propTypes = {
  learnosityItemReference: PropTypes.string.isRequired,
};

export default QuestionCalculator;
